import type { LigneMouvement } from '@mairistem/comptabilite';
import type { ErrorField } from '@mairistem/liste';
import PROFIL_ECRITURE from '../../../constants/mouvements/codeProfilEcritures';
import { MODE_REGLEMENT } from '../../../constants/mouvements/modeReglements';
import NATURE_PIECE from '../../../constants/mouvements/naturePiece';
import NATURE_PIECE_ORIGINE from '../../../constants/mouvements/naturePieceOrigine';
import { TYPE_BORDEREAU } from '../../../constants/mouvements/typeBordereau';
import TYPE_PIECE from '../../../constants/mouvements/typePiece';
import CompteDeTiersPanel from '../panel/CompteDeTiersPanel';
import CovidPanel from '../panel/CovidPanel';
import FctvaPanel from '../panel/FctvaPanel';
import MandatAnnulationReductionPanel from '../panel/InformationsRattachement/MandatAnnulationReductionPanel';
import InventairePanel from '../panel/InventairePanel';
import NumeroEmpruntPanel from '../panel/NumeroEmpruntPanel';
import PeriodeCouvertePanel from '../panel/PeriodeCouvertePanel';
import ProjetPanel from '../panel/ProjetPanel';
import TravauxEnRegiePanel from '../panel/TravauxEnRegiePanel';
import BaseProfilRattachement from './Base/BaseProfilRattachement';

class ProfilEcritureAnnulTitreInvestExeAnterieurDepense extends BaseProfilRattachement {
	constructor(anneeExercice: number) {
		super();
		this.code = PROFIL_ECRITURE.DEPENSE.ANNUL_TITRE_INVES_EXE_ANTERIEUR;
		this.typeBordereau = TYPE_BORDEREAU.DEPENSE.ORDINAIRE;
		this.naturePiece = NATURE_PIECE.DEPENSE.ANNUL_TITRE;
		this.typePiece = TYPE_PIECE.DEPENSE.CORRECTIF;
		this.imputation.articles = ['673', '678', '6588'];
		this.modeDeReglement = [MODE_REGLEMENT.DEPENSE.VIREMENT_INTERNE];
		this.defaultModeReglement = MODE_REGLEMENT.DEPENSE.VIREMENT_INTERNE;
		this.naturePieceOrigine = NATURE_PIECE_ORIGINE.MANDAT.TITRE.CODE;
		this.exerRattachement = anneeExercice.toString();
		this.panels = [
			new CompteDeTiersPanel(),
			new CovidPanel(),
			new FctvaPanel(),
			new InventairePanel(),
			new NumeroEmpruntPanel(),
			new PeriodeCouvertePanel(),
			new ProjetPanel(),
			new TravauxEnRegiePanel(),
			new MandatAnnulationReductionPanel(true),
			// add "Marche public" optional panel
			// add "Nomenclature achat" optional panel
		];
	}

	getLigneDefaultAttributes(): object {
		return {
			...super.getLigneDefaultAttributes(),
			exerRattachement: (parseInt(this.exerRattachement, 10) - 1).toString(),
		};
	}

	checkLigne(ligne: LigneMouvement): ErrorField[] {
		return [
			...super.checkLigne(ligne),
			...this.checkExerRattachementDifferent(ligne),
			...this.checkPieceOrigineRenseignee(ligne),
			...this.checkIdLigneOriginePesRenseigne(ligne),
		];
	}
}

export default ProfilEcritureAnnulTitreInvestExeAnterieurDepense;
